import { Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";

export const classes: Record<string, SystemStyleObject<Theme>> = {
  content: {
    flexGrow: 1,
    height: "calc(100vh - 170px)",
    display: "flex",
    justifyContent: "center",
    width: "100%",
    backgroundColor: "dark.primary",
  },
  root: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    overflow: "hidden",
  },

  children: {
    width: "100%",
    overflow: "auto",
    maxHeight: "100vh",
  },

  spacing: {
    padding: ({ spacing }) => ({
      xs: spacing(2),
      sm: spacing(4),
    }),
  },
};

export default classes;
